import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import {Grid,Divider} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { withStyles } from "@material-ui/core/styles";
import { history } from '../components/helpers/History';
import { UserActions } from '../redux/actions/UserActions';
import Cancel from '@material-ui/icons/Cancel';



import Logo from '../components/logo/HomeLogo'

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: '#fff',
    padding : theme.spacing(6),
  },
  cancelIcon: {
    margin: theme.spacing(1),
    fontSize: 40
  },
  typography: {
    margin: theme.spacing(1),
  },form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },divider:{
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
});

class SessionExpired extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
        username: '',
        password: '',
        submitted: false
    };

    this.handleSubmitButton = this.handleSubmitButton.bind(this);
}

handleSubmitButton(e) {
  this.props.logout();
  history.push('/login');
}

  render(){
    const classes = this.props.classes;
    return (
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Paper className={classes.paper}>
          <Logo></Logo>
          <Cancel color="secondary" className={classes.cancelIcon} />

          <Typography component="h1" variant="h4" color="secondary" className={classes.typography}>
            Ooops,
          </Typography>
          <Typography component="h1" variant="h5" className={classes.typography}>
            Session Expired. Please login again.
          </Typography>
          <Button variant="contained" color="primary" className={classes.button}
            onClick={this.handleSubmitButton}>
                Login
              </Button>
        </Paper>
      </Container>
    );
  }
}

function mapState(state) {
  const { loggingIn } = state.authentication;
  return { loggingIn };
}

const actionCreators = {
  login: UserActions.login,
  logout: UserActions.logout
};



const connectedSessionExpired = connect(mapState, actionCreators)(withStyles(useStyles,{ withTheme: true })(SessionExpired));
export { connectedSessionExpired as SessionExpired };